<crm-multi-select
  [options]="bankDetails"
  [(selectedItems)]="selectedBankDetails"
  (selectedItemsChange)="selectedBankDetailsChange.emit($event)"
  [label]="labelInput ? 'Расчетный счет' : ''"
  [virtualScroll]="true"
  [virtualScrollItemSize]="64"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [maxSelectedLabels]="0"
  [placeholder]="placeholder"
  display=""
  filterBy="checkingAccount, bank.name">
  <ng-template
    #selectedItemsTemplate
    let-bankDetails="items">
    <ng-container *ngFor="let bankDetail of bankDetails; last as isLast">
      {{ toBankDetail(bankDetail)?.checkingAccount }}{{ isLast ? '' : ', ' }}
    </ng-container>
  </ng-template>
  <ng-template
    #itemTemplate
    let-bankDetail="item">
    <div
      *ngIf="toBankDetail(bankDetail) as bankDetail"
      class="white-space-normal py-2">
      <div class="mb-1">{{ bankDetail?.name }}</div>
      <div class="text-gray-500">{{ bankDetail.checkingAccount }}</div>
    </div>
  </ng-template>
</crm-multi-select>
